import BaseService from '@/services/BaseService';

class AgencyProfileService extends BaseService {
    agencyServices = (id, filters) => this.post(`/agency/serviceshareagency/${id}`, filters || {});

    agencyProfile = (id) => this.get(`/agency/viewAgencyB2B/${id}`);
}
export default new AgencyProfileService();
